import { createTheme } from "@mui/material";
import { broadsheetCssVars, broadsheetLight } from "@/src/themes/broadsheet";
import {
  FONT_TEXT,
  STICKY_TOP,
} from "@/src/components/common/broadsheet/tokens";
import SelectCaret from "@/src/components/common/broadsheet/select-caret";

const lightTheme = createTheme({
  spacing: (factor: number) => `${factor}rem`,
  shape: {
    borderRadius: 0,
  },
  palette: {
    mode: "light",
    background: {
      default: "#FAF9F5",
      paper: "#FAF9F5",
    },
    text: {
      primary: "#4c4c4c",
      secondary: "#656d75",
    },
    primary: {
      main: "#0b7783",
    },
    secondary: {
      main: "#d3b976",
    },
    success: {
      main: "#177c40",
    },
    warning: {
      main: "#dcb95c",
    },
    error: {
      main: "#bf5639",
    },
    info: {
      main: "#bcd9dd",
    },
    divider: "#001e1d",
    common: {
      black: "#000000",
      white: "#ffffff",
    },
    custom: {
      ...broadsheetLight,
    },
  },
  typography: {
    fontFamily: FONT_TEXT,
    fontSize: 14,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...broadsheetCssVars(broadsheetLight),
        html: {
          WebkitTapHighlightColor: "transparent",
        },
        "::selection": {
          backgroundColor: "var(--bf-rule)",
          color: "var(--bf-ink)",
        },
        ":focus-visible": {
          outline: "2px solid var(--bf-spine-teal)",
          outlineOffset: "2px",
        },
        "[id]": {
          scrollMarginTop: STICKY_TOP,
        },
        ".MuiPickersOutlinedInput-root.MuiPickersOutlinedInput-root, .MuiPickersOutlinedInput-notchedOutline.MuiPickersOutlinedInput-notchedOutline":
          {
            borderRadius: 0,
          },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 0 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 0 },
        notchedOutline: { borderRadius: 0 },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: <SelectCaret />,
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: SelectCaret,
      },
      styleOverrides: {
        select: { borderRadius: 0 },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          verticalAlign: "middle",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "underline",
          "&:has(button)": {
            textDecoration: "none",
          },
        },
      },
    },
  },
});

export default lightTheme;
